import * as React from 'react';
import { ActionBar } from '@workwave-tidal/core/components/ActionBar'
import { WormholeChildren, useWormhole } from '@workwave-tidal/core/hooks/useWormhole'
import type { ConversationHeaderProps } from '../../types.js'
import { useConversationTexts } from '../LocaleProvider.js'
import { useWormholeId } from '../WormholeIdProvider.js'
import { ConversationHeaderRoot } from './components/ConversationHeaderRoot.js'

export function ConversationHeader(props: ConversationHeaderProps) {
  const {
    sx,
    testId,
    children,
    className,
    slotProps: { actionBar, root } = {},
  } = props

  const texts = useConversationTexts()
  const { worms: content } = useWormhole(useWormholeId('headerContent'))
  const { worms: actions } = useWormhole(useWormholeId('headerActions'))

  return (
    <ConversationHeaderRoot
      data-tidal="ConversationHeader"
      data-testid={testId}
      {...root}
      sx={sx}
      className={className}
    >
      {content}
      <ActionBar limit={1} menuTooltip={texts.header.overflowMenuTooltip} {...actionBar}>
        {actions}
      </ActionBar>

      <WormholeChildren>{children}</WormholeChildren>
    </ConversationHeaderRoot>
  )
}
